import React, { useCallback } from "react";
import { GoodsamInsuranceMobileTableTds, GoodsamInsuranceMobileTableThs, GoodsamInsuranceMobileTableDeductibleTds } from "../index";
import { PLAN_NAMES, SPEC_RENDER_IDS } from "../../constants";
import classes from "./GoodsamInsuranceMobileTable.module.css";
import cn from 'classnames';

const getSelectedPlanIndex = (selectedPlan, tableThs) => {
  if (!selectedPlan) {
    const defaultIndex = tableThs.findIndex((item) => item.isDefault);
    return defaultIndex >= 0 ? defaultIndex : 0;
  }

  const foundIndex = tableThs.findIndex((item) =>
    item.planName?.planId === selectedPlan.id ||
    item.price?.planId === selectedPlan.id
  );

  return foundIndex >= 0 ? foundIndex : 0;
};

export const GoodsamInsuranceMobileTable = (props) => {
  const { tableTds = [], tableThs = [], plans = [], selectedPlan, onSelectInsurance, specRenderFromProps } = props;
  const selectedPlanIndex = getSelectedPlanIndex(selectedPlan, tableThs);

  const handleColumnClick = useCallback((planId) => {
    const originalPlan = plans.find(plan => plan.id === planId);
    onSelectInsurance(originalPlan);
  }, [onSelectInsurance, plans]);

  const handleSpecRender = useCallback(({ groupData, planData, plan, index }) => {
    if (plan.id === SPEC_RENDER_IDS.DEDUCTIBLE) {
      return (
        <GoodsamInsuranceMobileTableDeductibleTds
          isSelectedPlan={selectedPlanIndex === index}
          onClick={() => handleColumnClick(plan.id)}
          groupData={groupData}
          planData={planData}
        />
      );
    }
  }, [handleColumnClick, selectedPlanIndex]);

  return (
    <div className={classes.container}>
      <div className={classes.table}>
        {plans.map((plan, index) => {
          const thItem = tableThs[index];
          const tdItems = tableTds[index]?.items;

          return (
            <div className={cn(
              classes.tableItem,
              selectedPlanIndex === index && classes.selectedPlan,
              selectedPlanIndex === index && classes.columnSelected,
              plan?.name === PLAN_NAMES.BETTER && classes.boxBorder,
            )}
            isSelectedPlan={selectedPlanIndex === index}
            >
              <header className={classes.header}>
                <GoodsamInsuranceMobileTableThs
                  {...thItem}
                  planId={plan.id}
                  isSelectedPlan={selectedPlanIndex === index}
                  onClick={() => handleColumnClick(plan.id)}
                  promo={plan.promo}
                  promoType={plan.promoType}
                />
              </header>
              <div className={classes.content}>
                {tdItems.map(({ groupData, planData }) => {
                  const specRender = specRenderFromProps ? specRenderFromProps({ groupData, planData, plan: planData, index }) : handleSpecRender({ groupData, planData, plan: planData, index });

                  return(
                    <div
                      className={cn(
                        classes.contentItemContainer,
                        groupData.isGroupStart && classes.groupStart,
                        groupData.isGroupEnd && classes.groupEnd
                      )}
                      key={groupData.id}
                    >
                      <div
                        className={cn(
                          classes.contentItem,
                          specRender && classes.deductible,
                          specRender && selectedPlanIndex === index && classes.deductibleSelected,
                        )}
                      >
                        {specRender ? specRender : (
                          <GoodsamInsuranceMobileTableTds
                            isSelectedPlan={selectedPlanIndex === index}
                            onClick={() => handleColumnClick(plan.id)}
                            groupData={groupData}
                            planData={planData}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
